export { getSuspenseCache } from "./cache/getSuspenseCache.js";
export { InternalQueryReference, getWrappedPromise, unwrapQueryRef, updateWrappedQueryRef, wrapQueryRef, assertWrappedQueryRef, } from "./cache/QueryReference.js";
//# sourceMappingURL=index.js.map